import React from "react";
import back_arrow from "../assets/svg/back-arrow.svg";
import { useNavigate, useLocation } from "react-router-dom";
import ProjectViewPage_header from "../Component/Header/ProjectViewPage_header";
import checked_icon from "../assets/svg/checked_icon.svg";
import removed_icon from "../assets/svg/removed_icon.svg";
import CommonFooter from "../CommonFooter/CommonFooter";

const ProjectViewPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const project = state?.project;

    return (
        <>
            <ProjectViewPage_header onSearch={null} disableSearch={true}  />
            <div>
                <div className="jobs-module-header">
                    <div className="jobs-module-header-left">
                        <img
                            src={back_arrow}
                            alt="Back Arrow"
                            onClick={() => navigate(-1)}
                            style={{ cursor: "pointer", width: "30px", height: "30px" }}
                        />
                        <p className="new_job" style={{ fontSize: "15px" }}>
                            {project?.code || "Code"}
                        </p>
                    </div>
                </div>

                {/* Project Details */}
                <div className="jobs-module-details">

                    <div className="jobs-module-job-details">
                        <p className="jobs-module-jobs-details-header">Project details</p>

                        <div className="jobs-module-details-grid">

                            <p className="jobs-module-jobs-details-label">Division Type</p>
                            <p className="jobs-module-jobs-details-value">
                                {project?.division_type?.length
                                    ? project.division_type.map(d => d.toUpperCase()).join(", ")
                                    : "-"}
                            </p>

                            <p className="jobs-module-jobs-details-label">Project Code</p>
                            <p className="jobs-module-jobs-details-value">{project?.code || "-"}</p>

                            <p className="jobs-module-jobs-details-label">Project Name</p>
                            <p className="jobs-module-jobs-details-value">{project?.name || "-"}</p>

                            {/* <p className="jobs-module-jobs-details-label">Project Man shift</p>
                            <p className="jobs-module-jobs-details-value">
                                {project?.project_man_shift || "-"}
                            </p>

                            <p className="jobs-module-jobs-details-label">Model</p>
                            <p className="jobs-module-jobs-details-value">{project?.modelCode || "-"}</p> */}

                            <p className="jobs-module-jobs-details-label">Customer Name</p>
                            <p className="jobs-module-jobs-details-value">
                                {project?.customer_name || "-"}
                            </p>

                            <p className="jobs-module-jobs-details-label">Backdated Days</p>
                            <p className="jobs-module-jobs-details-value">
                                {project?.backdated_days || "-"}
                            </p>

                            <p className="jobs-module-jobs-details-label">Plant Code</p>
                            <p className="jobs-module-jobs-details-value">
                                {project?.plant_code || "-"}
                            </p>

                            <p className="jobs-module-jobs-details-label">Profit Centre</p>
                            <p className="jobs-module-jobs-details-value">{project?.profit_centre || "-"}</p>

                            <p className="jobs-module-jobs-details-label">Cost Centre</p>
                            <p className="jobs-module-jobs-details-value">{project?.cost_centre || "-"}</p>
                        </div>
                    </div>

                    <div className="project-viewpage-right-column">
                        <div className="project-viewpage-card">
                            <p className="project-viewpage-header">Other details</p>

                            <div className="project-viewpage-details-grid">
                                <p className="project-viewpage-label">Location</p>
                                <p className="project-viewpage-value">
                                    {project?.location_name || "-"}
                                </p>

                                <p className="project-viewpage-label">State</p>
                                <p className="project-viewpage-value">
                                    {project?.state_name || "-"}
                                </p>

                                <p className="project-viewpage-label">Region</p>
                                <p className="project-viewpage-value">
                                    {project?.region || "-"}
                                </p>

                                <p className="project-viewpage-label">Mail ID</p>
                                <div className="project-viewpage-mail-chips">
                                    {project?.mail_ids ? (
                                        project.mail_ids.split(",").map((mail, index) => (
                                            <span key={index} className="project-viewpage-mail-chip">
                                                {mail.trim()}
                                            </span>
                                        ))
                                    ) : (
                                        <span className="project-viewpage-mail-chip">-</span>
                                    )}
                                </div>

                            </div>
                        </div>

                        {/* JOB TYPES CARD */}
                        <div className="project-viewpage-card">
                            <p className="project-viewpage-header">
                                Job types {project?.jobtype?.length ? `- ${project.jobtype.length}` : ""}
                            </p>

                            <div className="project-viewpage-jobtypes">
                                {project?.jobtype?.length > 0 ? (
                                    project.jobtype.map((job) => (
                                        <span
                                            key={job.value}
                                            className="project-viewpage-jobtype-chip"
                                        >
                                            {job.label}
                                        </span>
                                    ))
                                ) : (
                                    <p className="project-viewpage-empty">No job types</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Charges Table */}
                <div
                    className="projectviewpage"
                    style={{
                        background: "#ffffff", padding: "15px", marginTop: '10px', boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                        borderRadius: "8px"
                    }}
                >
                    <p
                        style={{
                            fontSize: "15px",
                            fontWeight: "600",
                            marginBottom: "12px",
                            textAlign: "center",
                            color: "#333",
                            display: "inline-block",
                            paddingBottom: "4px",
                            fontFamily: 'Work Sans'
                        }}
                    >
                        Charges
                    </p>

                    <div style={{width:'100%'}}>
                        <table
                            style={{
                                borderCollapse: "collapse",
                                border: "1px solid #ddd",
                                margin: "0 auto",
                            }}
                        >

                            <thead style={{ background: "#f1f1f1" }}>
                                <tr>
                                    <th style={{ textAlign: 'center' }} className="table-heading">S.No</th>
                                    <th style={{ textAlign: 'center' }} className="table-heading">Charge Code</th>
                                    <th style={{ textAlign: 'center' }} className="table-heading">Sales Supporting Document</th>
                                    <th style={{ textAlign: 'center' }} className="table-heading" >Cost Supporting Document</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {project?.charges?.length > 0 ? (
                                    project.charges.map((charge, index) => (
                                        <tr key={charge.value}>
                                            <td style={{ textAlign: 'center' }} className="table-cell">{index + 1}</td>
                                            <td style={{ textAlign: 'center' }} className="table-cell">{charge.label}</td>
                                            <td style={{ textAlign: 'center' }} className="table-cell" >
                                                {charge.sales_supporting_doc ? (
                                                    <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}><img
                                                        src={checked_icon}
                                                        alt="Yes"
                                                        style={{ width: "20px", height: "20px", marginRight: "5px" }}
                                                    />Yes</span>
                                                ) : (
                                                    <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}><img
                                                        src={removed_icon}
                                                        alt="No"
                                                        style={{ width: "20px", height: "20px", marginRight: "5px" }}
                                                    />No</span>
                                                )}
                                            </td>
                                            <td style={{ textAlign: 'center' }} className="table-cell">
                                                {charge.cost_supporting_doc ? (
                                                    <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}><img
                                                        src={checked_icon}
                                                        alt="Yes"
                                                        style={{ width: "20px", height: "20px", marginRight: "5px" }}
                                                    />Yes</span>
                                                ) : (
                                                    <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}><img
                                                        src={removed_icon}
                                                        alt="No"
                                                        style={{ width: "20px", height: "20px", marginRight: "5px" }}
                                                    />No</span>
                                                )}
                                            </td>
                                            <td></td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td className="table-cell" colSpan="4" style={{ textAlign: "center" }}>
                                            No charges found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <CommonFooter />
        </>
    );
};

export default ProjectViewPage;
